<ng-template #loading>
  <app-loading-indicator
    class="d-flex w-100 h-100"
    [showBackdrop]="true"
    minHeight="780px"
    [size]="loadingIndicatorSizes.SEVEN_X"
  >
  </app-loading-indicator>
</ng-template>

<div
  class="flex-column"
  *ngIf="currentProduct$ | async as currentProduct; else loading"
>
  <div class="crosses-modal-header modal-header">
    <h4 class="modal-title">
      <b> Crosses for </b> {{ currentProduct?.catalogNumber }}
    </h4>

    <div class="crosses-modal-with-search">
      <button
        class="btn btn-outline-secondary btn-sm"
        data-test-selector="no-equivalent-cross-button"
        *ngIf="
          showNoEquivalentCrossButton(currentProduct) &&
          (crossReferences$ | async)
        "
        (click)="markNoEquivalentCross(currentProduct)"
      >
        No Equivalent Cross
      </button>

      <app-search
        class="crosses-modal-search"
        *ngIf="crossReferencePermissions?.UPDATE_CROSS_REFERENCE?.hasAccess"
        [searchText]="searchTermSubject$.value"
        (searchTextChange)="searchTermSubject$.next($event)"
        placeHolderText="Find New Cross"
        [disabled]="this.userAccount?.isGPO"
        >
      </app-search>
      <button
        type="button"
        class="close btn"
        aria-label="Close"
        tabindex="-1"
        (click)="closeModal()"
      >
        <span aria-hidden="false" class="fa fal fa-times fa-lg"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <app-cross-product-card
      [categoryId]="categoryId"
      [product]="currentProduct"
      [isVoteVisible]="!userAccount?.isSeller"
      [featureFlags]="features"
      [categorizationSchemeId]="categorizationSchemeId"
    >
    </app-cross-product-card>

    <div>
      <!--Bread crumb search button.-->
      <button
        class="btn btn-sm btn-pill text-truncate wm-150 search-result-button"
        *ngIf="searchTermSubject$.getValue() && !(crossReferences$ | async)"
      >
        <i class="fas fa-times close-icon" (click)="clearSearch()"></i>
        <b>{{ (crossReferences$ | async)?.length }}</b> Result(s)
      </button>

      <app-cross-references-grid
        class="cross-modal-grid"
        [features]="features"
        [permissions]="crossReferencePermissions"
        [userAccount]="userAccount"
        [categorizationSchemeId]="categorizationSchemeId"
        [categoryId]="categoryId"
        [productId]="currentProduct.id"
        [crossReferenceOpinionOptions]="crossReferenceOpinionOptions"
        (promoteCrossEvent)="promoteCross(currentProduct, $event)"
        (removeCrossEvent)="removeCross(currentProduct, $event)"
        (addCrossEvent)="addCrossReference(currentProduct, $event)"
        (updateOpinionEvent)="updateOpinion(currentProduct, $event)"
        [isLoadingSearchResults]="isLoadingSearchResults"
        [isShowingSearchResults]="isShowingSearchResults"
        [crossReferences]="crossReferences$ | async"
      >
      </app-cross-references-grid>
    </div>
  </div>
</div>
